'use strict'

/**
 * Хранилище для плейлиста
 */

import * as types from '@/store/types'

const state = {
  items: [],
  adItems: null,
  speakId: null,
  volumeSetting: null,
  mediaMute: false
}

const mutations = {
  [types.PLAYLIST.items.set]: (store, value) => {
    store.items = value
  },
  [types.PLAYLIST.adItems.set]: (store, value) => {
    store.adItems = value
  },
  [types.PLAYLIST.speakId.set]: (store, value) => {
    store.speakId = value
  },
  [types.PLAYLIST.speakId.reset]: (store, value) => {
    store.speakId = null
  },
  [types.PLAYLIST.volumeSetting.set]: (store, value) => {
    store.volumeSetting = value
  },
  [types.PLAYLIST.mediaMute.set]: (store, value) => {
    store.mediaMute = true
  },
  [types.PLAYLIST.mediaMute.reset]: (store, value) => {
    store.mediaMute = false
  }
}

const actions = {
  [types.PLAYLIST.items.set] (context, value) {
    context.commit(types.PLAYLIST.items.set, value)
  },
  [types.PLAYLIST.adItems.set] (context, value) {
    context.commit(types.PLAYLIST.adItems.set, value)
  },
  [types.PLAYLIST.speakId.set] (context, value) {
    context.commit(types.PLAYLIST.speakId.set, value)
  },
  [types.PLAYLIST.speakId.reset] (context, value) {
    context.commit(types.PLAYLIST.speakId.reset, value)
  },
  [types.PLAYLIST.volumeSetting.set] (context, value) {
    context.commit(types.PLAYLIST.volumeSetting.set, value)
  },
  [types.PLAYLIST.mediaMute.set] (context, value) {
    context.commit(types.PLAYLIST.mediaMute.set, value)
  },
  [types.PLAYLIST.mediaMute.reset] (context, value) {
    context.commit(types.PLAYLIST.mediaMute.reset, value)
  }
}

export default {
  state,
  mutations,
  actions
}
